var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "UiCompletionCard",
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center mb-2 gap-2" },
        [
          _c("UiCompletionStepper", {
            attrs: {
              steps: _vm.rules.max,
              current: _vm.rules.rules_length,
              status: _vm.rules.stepper_status,
            },
          }),
          _vm._v(" "),
          _c("strong", { staticClass: "ml-2" }, [
            _vm.rules.status === "none"
              ? _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("watchmen.channels.indicator.none")
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.rules.status === "low"
              ? _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("watchmen.channels.indicator.low")
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.rules.status === "complete"
              ? _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("watchmen.channels.indicator.complete")
                    ),
                  },
                })
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "UiCompletionList",
        [
          _c(
            "UiCompletionLine",
            { attrs: { is_completed: _vm.rulesIncludes("one_mobile") } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("watchmen.channels.indicator.one_mobile")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "UiCompletionLine",
            { attrs: { is_completed: _vm.rulesIncludes("two_watchmen") } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("watchmen.channels.indicator.two_watchmen")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "UiCompletionLine",
            { attrs: { is_completed: _vm.rulesIncludes("has_validated") } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("watchmen.channels.indicator.has_validated")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }